import isConsultationFromStatic from '@/utils/isConsultationFromStatic';
import { getStepName } from '@/utils/stepUtils';

type ConsultationLinkProps = {
  stepId?: string;
};
export const useConsultationLink = ({ stepId = '' }: ConsultationLinkProps) => {
  // export const useConsultationLink = (isPhoneConsultation = false, isSalesConsultation = false) => {
  // const partnership = usePartnership();

  // if (partnership && hasValidPartnership(partnership)) {
  //   if (partnersMap.get(partnership) === partnersMap.get('finfit')) {
  //     return 'https://calendly.com/d/cm6h-qvg-8j6/20-minute-consultation';
  //   }
  // }

  // if (isSalesConsultation) {
  //   return 'https://calendly.com/d/csys-mpw-s5p/resolve-free-consult';
  // }

  // if (isPhoneConsultation) {
  //   return 'https://calendly.com/d/cm6h-qvg-8j6/20-minute-consultation';
  // }

  // return 'https://calendly.com/d/cm6h-qvg-8j6/20-minute-consultation';

  const stepName = getStepName(stepId);
  return isConsultationFromStatic({ stepName })
    ? 'https://calendly.com/d/csrs-54p-mh8/resolve-free-consult'
    : 'https://calendly.com/d/csys-mpw-s5p/resolve-free-consult';
};
